import React from 'react'
import VideoPresentation from './VideoPresentation.mp4'
import VideoPresentationPoster from './VideoPresentationPoster.png'
import AnimatedSection from '../../Hook/Block'
import Office1 from './Office1.png'
import Office2 from './Office2.png'
import Office3 from './Office3.png'
import EBP1 from './EBP1.jpg'
import EBP2 from './EBP2.jpg'
import EBP3 from './EBP3.png'
import WIN1 from './WIN1.png'
import WIN2 from './WIN2.png'
import WIN3 from './WIN3.png'
import ZEE1 from "./ZEE1.png"
import ZEE2 from "./ZEE2.png"
import ZEE3 from "./ZEE3.png"
import NOCRM2 from "./NOCRM2.png"
import NOCRM3 from "./NOCRM3.png"
import NOCRM1 from "./NOCRM1.png"
import SEO from '../../Hook/Seo'
import BreadcrumbsSchema from '../../Hook/BreadcrumbsSchema'
const Logiciel = () => {
    return (
        <>
            <SEO
                title="Logiciels & Microsoft 365 | AM Services dans les Vosges"
                description="Licences Microsoft 365, sécurité, messagerie, sauvegarde et intégration applicative dans les Vosges."
                path="/logiciel"
                keywords={["Microsoft 365", "licences", "sécurité M365", "messagerie pro", "sauvegarde cloud"]}
            />
            <BreadcrumbsSchema />
            <div className="container">
                <div className="div_container">
                    <h1 className="sr-only">Logiciels & Microsoft 365 pour les PME dans les Vosges</h1>
                    <video
                        src={VideoPresentation}
                        poster={VideoPresentationPoster}
                        autoPlay
                        muted
                        loop
                        preload="auto"
                        playsInline
                        className="background-video"
                        aria-label="Vidéo de présentation des services AM Services"
                    />
                    <div className="info-hero-center-text">
                    <h1 className="info-title">LOGICIELS PROFESSIONNELS</h1>
                    <p className="info-lead">
                        Chez AMServices, votre téléphonie professionnelle est simple, fluide et connectée.
                    </p>
                    </div>
                    <div className="scroll-indicator" onClick={() => document.getElementById('game-content-start').scrollIntoView({ behavior: 'smooth' })}>
          <span className="arrow"></span>
        </div>
                </div>
                <AnimatedSection
                    id='Office'
                    sectionTitle="Office 365"
                    direction="left"
                    items={[
                        {
                            img: Office1,
                            alt: "Installation et configuration",
                            title: "Installation et configuration",
                            text: "Nous gérons l'installation et la configuration de vos licences Office 365 sur vos postes de travail, serveurs ou environnements cloud."
                        },
                        {
                            img: Office2,
                            alt: "Mises à jour et maintenance",
                            title: "Mises à jour et maintenance",
                            text: "Nous assurons la maintenance proactive et les mises à jour de sécurité pour garantir la performance et l'intégrité de vos outils bureautiques."
                        },
                        {
                            img: Office3,
                            alt: "Support et optimisation",
                            title: "Support et optimisation",
                            text: "Nous offrons un support technique spécialisé et des services d'optimisation pour maximiser la productivité de votre suite Microsoft Office."
                        }
                    ]}
                />
                <AnimatedSection
                    id='EBP'
                    sectionTitle="EBP "
                    direction="right"
                    items={[
                        {
                            img: EBP1,
                            alt: "Intégration sur-mesure",
                            title: "Intégration sur-mesure",
                            text: "Nous prenons en charge l'installation et la configuration de votre logiciel de gestion EBP, afin de l'intégrer parfaitement à votre système d'information existant (SI)."
                        },
                        {
                            img: EBP2,
                            alt: "Conformité et évolutivité",
                            title: "Conformité et évolutivité",
                            text: "Nous assurons la maintenance et les mises à jour régulières de votre logiciel pour garantir sa conformité aux dernières normes comptables et son évolutivité fonctionnelle."
                        },
                        {
                            img: EBP3,
                            alt: "Support technique",
                            title: "Support technique",
                            text: "Nous proposons un support technique dédié pour vous permettre de maîtriser pleinement EBP et d'optimiser vos processus de gestion."
                        }
                    ]}
                />
                <AnimatedSection
                    id='Windows'
                    sectionTitle="Microsoft Windows"
                    direction="left"
                    items={[
                        {
                            img: WIN1,
                            alt: "Mise en service",
                            title: "Mise en service",
                            text: "Nous gérons l'installation et la configuration de votre système d'exploitation Windows, pour une intégration parfaite dans votre environnement de travail."
                        },
                        {
                            img: WIN2,
                            alt: "Maintien en condition opérationnelle",
                            title: "Maintien en condition opérationnelle",
                            text: "Nous assurons la maintenance et les mises à jour régulières de Windows, afin de garantir la performance et la sécurité de votre parc informatique."
                        },
                        {
                            img: WIN3,
                            alt: "Assistance technique",
                            title: "Assistance technique",
                            text: "Nous vous proposons un support technique dédié pour vous aider à maîtriser Windows et à résoudre les problèmes que vous pourriez rencontrer."
                        }
                    ]}
                />
                <AnimatedSection
                    id='Zeendoc'
                    sectionTitle="Zeendoc"
                    direction="right"
                    items={[
                        {
                            img: ZEE1,
                            alt: "Intégration sur-mesure",
                            title: "Intégration sur-mesure",
                            text: "Nous gérons l'installation et la configuration de votre solution de gestion électronique de documents Zeendoc, pour une intégration parfaite avec vos logiciels métiers."
                        },
                        {
                            img: ZEE2,
                            alt: "Conformité et sécurité",
                            title: "Conformité et sécurité",
                            text: "Nous assurons les mises à jour régulières de Zeendoc pour garantir la conformité de vos documents aux dernières normes légales et la sécurité de vos données."
                        },
                        {
                            img: ZEE3,
                            alt: "Support et maîtrise",
                            title: "Support et maîtrise",
                            text: "Nous proposons un support technique dédié pour vous aider à maîtriser pleinement Zeendoc et à optimiser vos processus de gestion documentaire."
                        }
                    ]}
                />
                <AnimatedSection
                    id='Nocrm'
                    sectionTitle="Nocrm"
                    direction="right"
                    items={[
                        {
                            img: NOCRM1,
                            alt: "Intégration sur-mesure",
                            title: "Intégration sur-mesure",
                            text: "Nous gérons l'installation et la configuration de votre compte Nocrm, en l'adaptant à votre processus de vente pour une intégration parfaite avec vos logiciels métiers."
                        },
                        {
                            img: NOCRM2,
                            alt: "Optimisation continue",
                            title: "Optimisation continue",
                            text: "Nous assurons les mises à jour et la maintenance de votre solution Nocrm pour garantir un flux de travail performant et sécurisé pour votre équipe commerciale."
                        },
                        {
                            img: NOCRM3,
                            alt: "Support et formation",
                            title: "Support et formation",
                            text: "Nous vous proposons un support technique dédié pour vous aider à maîtriser Nocrm et à optimiser la gestion de vos prospects."
                        }
                    ]}
                />
            </div>
        </>
    )
}

export default Logiciel